import SvgIcon from '@mui/material/SvgIcon';

export const PlusIcon = (props) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M13 11V4H11V11H4V13H11V20H13V13H20V11H13Z" />
  </SvgIcon>
);
